import { defineStore } from "pinia";
import { findByToken } from "@/api/login.js";
import { getDefaultCassetteId } from "@/api/discover.js";
import { setLocalStor } from "../util/index.js";

export const useCounterStore = defineStore("counter", {
  // other options like state, getters, actions
  state: () => ({
    user: null,
    d_cassetId: null,
  }),
  getters: {}, // other getters
  actions: {
    getUserMessage() {
      return new Promise((resolve, reject) => {
        if (localStorage.getItem("userMessage")) {
          let obj = JSON.parse(localStorage.getItem("userMessage"));
          let type = "";
          if (window.keymemoApi) {
            type = window.keymemoApi.getEquipment() ? "desktop" : "";
          }
          findByToken(obj.token, type)
            .then((res) => {
              if (res.code == "200") {
                setLocalStor("userMessage", {
                  token: res.data.token,
                });
                this.user = res.data;
                resolve();
              } else {
                localStorage.clear();
                this.user = null;
                reject("登录失效");
              }
            })
            .catch(() => {
              reject("未登录");
            });
        } else {
          this.user = null;
          reject("未登录");
        }
      });
    },
    getCassetId() {
      return new Promise((resolve, reject) => {
        if (this.d_cassetId) {
          resolve(this.d_cassetId);
        } else {
          getDefaultCassetteId().then((res) => {
            this.d_cassetId = res.data.id;
            resolve(this.d_cassetId);
          });
        }
      });
    },
  },
});
